import { Card, CardContent, FormControl, Select, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import axios from 'src/utils/axios';
import { getPlate, getUser, setPlate } from 'src/utils/Common';
const useStyles = makeStyles((theme) => ({
    root: {},
    fields: {
        margin: theme.spacing(-1),
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            flexGrow: 1,
            margin: theme.spacing(1)
        }
    },
    submitButton: {
        marginTop: theme.spacing(1),
        width: '100%'
    }
}));

function Plaka() {
    const classes = useStyles();
    const SessionUser = getUser();
    var BirimKodu = SessionUser.ServiceShopId;
    const [plates, setPlates] = useState([]);
    const [value, setValue] = useState(getPlate());
    React.useEffect(() => {
        axios.get(`/GetArtemisBranchPlateNumbers/${SessionUser.ServiceShopId}`)
            .then(response => {
                if (response.data.length > 0) {
                    setPlates(response.data);
                }
            })
        // eslint-disable-next-line
    }, [BirimKodu]);

    const handleChange = (e) => {
        setPlate(e.target.value);
        setValue(e.target.value);
    }
    return (
        <Card>
            <CardContent>
                <FormControl variant="outlined" className={classes.fields}>
                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                        Seçili Plaka
                    </Typography>
                    <Typography variant="h6" component="h2">
                        {value}
                    </Typography>
                </FormControl>
                <FormControl variant="outlined" className={classes.fields}>
                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                        Plaka Seç
                    </Typography>
                    <Typography variant="h6" component="h2">
                        <Select
                            native
                            value={value}
                            onChange={handleChange}
                            label="Age"
                            fullWidth
                            labelId="plaka_label"
                            inputProps={{
                                name: "plaka_select",
                                id: "plaka_select"
                            }}
                        >
                            <option value="" defaultValue>{value}</option>
                            {plates.map(p => {
                                return <option key={p.PLAKA} value={p.PLAKA}>{p.PLAKA}</option>
                            })}
                        </Select>
                    </Typography>

                </FormControl>
            </CardContent>
        </Card>
    );
}


export default Plaka;
